module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0128.jpg?v=df5f381b";